import { useIsMutating } from "@tanstack/react-query";
import { GlobalLoaderOverlay } from "./globalLoaderOverlay";

export const GlobalLoader = () => {
  const isMutating = useIsMutating(); // 모든 mutation 추적

  return (
    <GlobalLoaderOverlay
      h="100vh"
      overlayColor="rgba(255, 255, 255, 0.5)" // 필요에 따라 수정
      visible={!!isMutating}
    />
  );
};
